var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_4793)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2476 13.8798H1.75241C1.52418 13.8817 1.29781 13.8387 1.08622 13.7531C0.874636 13.6675 0.68198 13.541 0.519252 13.381C0.356524 13.221 0.226912 13.0304 0.137819 12.8203C0.0487248 12.6102 0.001894 12.3846 0 12.1563V1.8446C0.001894 1.61637 0.0487248 1.39075 0.137819 1.18062C0.226912 0.970486 0.356524 0.779963 0.519252 0.619924C0.68198 0.459885 0.874636 0.333467 1.08622 0.247888C1.29781 0.162309 1.52418 0.119245 1.75241 0.121155H19.2476C19.4758 0.119245 19.7022 0.162309 19.9138 0.247888C20.1254 0.333467 20.318 0.459885 20.4807 0.619924C20.6435 0.779963 20.7731 0.970486 20.8622 1.18062C20.9513 1.39075 20.9981 1.61637 21 1.8446V12.1636C20.9943 12.6233 20.8067 13.0619 20.4782 13.3835C20.1498 13.7052 19.7073 13.8836 19.2476 13.8798ZM7.24138 4.34288C7.24138 4.00977 6.98793 3.74184 6.67655 3.74184H2.73724C2.42586 3.74184 2.17241 4.00977 2.17241 4.34288V6.7615C2.17241 7.0946 2.42586 7.36255 2.73724 7.36255H6.67655C6.98793 7.36255 7.24138 7.0946 7.24138 6.7615V4.34288Z",
    fill: "black",
    fillOpacity: 0.898
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1034 10.9834H15.931C15.4603 10.9834 15.2068 10.7662 15.2068 10.2593C15.2068 9.7524 15.4603 9.53516 15.931 9.53516H18.1034C18.5741 9.53516 18.8275 9.7524 18.8275 10.2593C18.8275 10.7662 18.5741 10.9834 18.1034 10.9834ZM13.7586 10.9834H11.5862C11.1155 10.9834 10.862 10.7662 10.862 10.2593C10.862 9.7524 11.1155 9.53516 11.5862 9.53516H13.7586C14.2293 9.53516 14.4827 9.7524 14.4827 10.2593C14.4827 10.7662 14.2293 10.9834 13.7586 10.9834ZM9.41374 10.9834H7.24133C6.77064 10.9834 6.51719 10.7662 6.51719 10.2593C6.51719 9.7524 6.77064 9.53516 7.24133 9.53516H9.41374C9.88443 9.53516 10.1379 9.7524 10.1379 10.2593C10.1379 10.7662 9.88443 10.9834 9.41374 10.9834ZM5.06891 10.9834H2.8965C2.42581 10.9834 2.17236 10.7662 2.17236 10.2593C2.17236 9.7524 2.42581 9.53516 2.8965 9.53516H5.06891C5.5396 9.53516 5.79305 9.7524 5.79305 10.2593C5.79305 10.7662 5.5396 10.9834 5.06891 10.9834Z",
    fill: "black",
    fillOpacity: 0.898
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_4793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 13.7586,
    fill: "white",
    transform: "translate(0 0.121094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCard);
export default __webpack_public_path__ + "static/media/grayCard.688c443f45ad0a2e86d6bad814338986.svg";
export { ForwardRef as ReactComponent };